<template>
    <CalcField full label="§calc.step3.fields.project_name">
        <CalcStringInput
            :model-value="projectName"
            placeholder="§calc.step3.fields.project_name_placeholder"
            :maxlength="30"
            @update:model-value="onInput"
        />
    </CalcField>
</template>

<script>
import CalcField from './CalcField.vue'
import CalcStringInput from './CalcStringInput.vue'

// Characters that are illegal/unsafe in file names across platforms:
// the Windows-reserved set (< > : " / \ | ? *) plus control characters.
// eslint-disable-next-line no-control-regex
const UNSAFE_FILENAME_CHARS = /[<>:"/\\|?*\u0000-\u001F\u007F-\u009F]/g

export default {
    name: 'CalcProjectName',

    components: { CalcField, CalcStringInput },

    props: {
        projectName: {
            type: String,
            default: '',
        },
    },

    emits: ['update:projectName'],

    methods: {
        onInput(value) {
            this.$emit(
                'update:projectName',
                (value || '').replace(UNSAFE_FILENAME_CHARS, ''),
            )
        },
    },
}
</script>
